import { useContext } from 'react'

import {
  ArcadeComponentMigrationConfig,
  ArcadeComponentMigrationFlags,
  useFeatureFlag,
} from '@cash-web/shared-data-access-feature-flags'

import { ArcadeFeatureContext } from './ArcadeFeatureContext'

export type ArcadeComponentType = ArcadeComponentMigrationFlags extends `cash-web-arcade-migration-${infer Component}`
  ? Component
  : never

export const useArcadeMigrationFeatureFlag = (component: ArcadeComponentType) => {
  const isArcadeFeatureEnabled = useContext(ArcadeFeatureContext)
  const arcadeMigrationFeatureFlag = useFeatureFlag('cash-web-arcade-migration')
  const flag = `cash-web-arcade-migration-${component}` as keyof ArcadeComponentMigrationConfig

  // Component flags should explicitly be enabled or disabled to be controlled
  if (component !== 'apps') {
    switch (arcadeMigrationFeatureFlag?.[flag]) {
      case 'ENABLED':
        return true
      case 'DISABLED':
        return false
      default:
        break
    }
  }

  // All components should be enabled if the Arcade feature context is not provided or is enabled
  return (
    isArcadeFeatureEnabled !== 'DISABLED' &&
    arcadeMigrationFeatureFlag?.['cash-web-arcade-migration-apps'] === 'ENABLED'
  )
}
